var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,28.5h0v-2a4,4,0,0,0-4-4h-8a4,4,0,0,0-4,4v2",
    transform: "translate(0 -6)",
    fill: "none",
    stroke: "#FF5C3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,8.5a4,4,0,1,1-4-4,4,4,0,0,1,4,4Z",
    transform: "translate(-2)",
    fill: "none",
    stroke: "#FF5C3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadOrange);
export default __webpack_public_path__ + "static/media/lead_orange.3bf7da077b08165719bf6590c5baa53a.svg";
export { ForwardRef as ReactComponent };